/* eslint-disable */
import Vue from 'vue'
import VCalendar from 'v-calendar'
import App from './App.vue'
// eslint-disable-next-line no-use-before-define
import Polyglot from "vue-polyglot"
var flatten = require('flat')


// "citizen-shared-components": "../citizenMBookingVueComponents",
//import 'citizen-shared-components/dist/components.css'

var config = {
	language: {},
	destinations: [],
	hotels: [],
	rates: [],
	dateFormat: "MM/DD/YYYY",
	dateFormatShort: "ddd D MMM",
	dateFormatUltraShort: "D MMM",
	destination: null,
	arrival: null,
	departure: null,
	guests: 1,
	rooms: 1,
	rate: null,
	promo: null,
	filteredDestinations: [],
	filteredHotels: [],
	filteredRates: [],
	mobileBreakpoint: 768,
	errorShowTime: 1882,
	endpoint: "https://citizenm.workmatrix.test/booking.json",
	currentlyLoading: !1,
	editMode: !1,
	availability: {},
	guestsMax: 2,
	roomsMax: 10,
	defaultRate: "BEST",
	where: 0,
	rate_code: null,
	promo_code: null,
	property_name: null,
	propertyCurrency: "EUR",
	continueButton: null,
	continueButtonText: "continue booking",
	confirmButtonIsSubmit: !1,
	continueButtonAvailable: !0,
	appEditLink: null,
	unEditable: !1,
	breakdown: [],
	total: [],
	taxes: null,
	subscription: null,
	activationValue: 0,
	activationDates: [],
	inactiveButtonOnLoad: false,
}

// configs
const configs = document.querySelectorAll("script.vue_config_override")
configs.forEach(conf => {
	try {
		let j = JSON.parse(conf.innerHTML);
		config = Object.assign(config, j);
	} catch (e) {
		console.warn(e)
	}
});
// prices
config.currency = config.propertyCurrency || 'EUR';
config.currency_symbols = window.currency_symbols;
config.currency_rates = window.rates;
config.currency_base = window.base;

// dates
config.departure = config.departure ? new Date(config.departure) : null;
config.arrival = config.arrival ? new Date(config.arrival) : null;

// translations
Vue.use(Polyglot, {
	defaultLanguage: "en",
	languagesAvailable: ["en"]
});

Vue.locales({
	en: flatten(config.language)
});


// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
});

// Vue.prototype.$root.appConfig = config;
new Vue({
	el: '#appVuePanel',
	created: function () {
		// this.$options.config = config
	},
	data: {
		appConfig: config
	},
	render: h => h(App),
});